import * as React from 'react'

function DownloadWhiteIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" {...props}>
      <g fill="none" stroke="#263238" strokeWidth={1}>
        <rect width={48} height={48} rx={4} stroke="none" />
      </g>
      <g data-name="Group 52715">
        <g data-name="Group 53635">
          <path
            data-name="Path 17173"
            d="M9.428 1.484H0V0h9.428z"
            transform="translate(14.857 16) rotate(-90 8.842 .586)"
            fill="#263238"
          />
          <path
            data-name="Path 17173"
            d="M18 1.484H0V0h18z"
            transform="translate(14.857 16) translate(0 14.516)"
            fill="#263238"
          />
          <path
            data-name="Path 17173"
            d="M7.653 1.484H0V0h7.653z"
            transform="translate(14.857 16) rotate(-90 7.602 7.601)"
            fill="#263238"
          />
          <path
            data-name="Path 17173"
            d="M7.653 1.484H0V0h7.653z"
            transform="translate(14.857 16) rotate(-90 15.86 -.657)"
            fill="#263238"
          />
          <g data-name="Group 52706">
            <path
              data-name="Subtraction 152"
              d="M6.1 6.036L0 6.1.059 0 1.53 1.471 1.5 4.6l3.125-.03 1.47 1.469z"
              fill="#263238"
              transform="translate(14.857 16) rotate(-45 10.664 -2.215)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default DownloadWhiteIcon
